import React, { forwardRef, useEffect, useRef, useState } from 'react';
import MaskedInput from 'react-text-mask';

import {
  Input,
  Container,
  ContainerInside,
  IconSpace,
  RightIcon,
  ErrorText,
  Label,
} from './styles';

function StyledInput(
  {
    defaultValue,
    label,
    labelColor = '#464e5f',
    type,
    onChange,
    onBlur,
    placeholder,
    icon,
    rightIcon,
    error,
    masked,
    guide,
    mask = [],
    containerStyle,
    inputAs,
    ...rest
  },
  ref
) {
  const [focus, setFocus] = useState(false);

  if (masked)
    return (
      <Container style={containerStyle}>
        {label && (
          <Label color={labelColor} type="label">
            {label}
          </Label>
        )}
        <ContainerInside focus={focus}>
          {icon && <IconSpace>{icon}</IconSpace>}
          <MaskedInput
            defaultValue={defaultValue}
            mask={mask}
            guide={guide}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
            render={(innerRef, props) => (
              <Input
                focus={focus}
                error={error}
                onFocus={() => setFocus(true)}
                placeholder={placeholder}
                onChange={onChange}
                ref={innerRef}
                type={type}
                {...props}
              />
            )}
          />
          {rightIcon && <RightIcon>{rightIcon}</RightIcon>}
        </ContainerInside>
        {error && (
          <ErrorText color="error" type="little">
            {error}
          </ErrorText>
        )}
      </Container>
    );

  return (
    <Container>
      {label && (
        <Label color={labelColor} type="label">
          {label}
        </Label>
      )}
      <ContainerInside>
        {icon && <IconSpace>{icon}</IconSpace>}
        <Input
          defaultValue={defaultValue}
          focus={focus}
          error={error}
          onFocus={() => setFocus(true)}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          type={type}
          ref={ref}
          as={inputAs}
          {...rest}
        />
      </ContainerInside>
      {error && (
        <ErrorText color="error" type="little">
          {error}
        </ErrorText>
      )}
    </Container>
  );
}

export default forwardRef(StyledInput);
